import { createAction } from "@reduxjs/toolkit";
type createModuleData = {
  name: string,
  discription: string,
  type?: string,
  syllabus?: string,
  edx_course_id?: string,
  edx_course_display_names?: string,
  exam_duration?: number,
  exam_pass_score?: number
  status?: 0 | 1;
  max_exams_students?: number
}

type cloneModuleData = {
  name: string,
  discription: string,
  edx_course_id?: string,
  edx_course_display_names?: string,
  exam_duration?: number,
  exam_pass_score?: number
  status: 0 | 1;
}

export type createSubModuleParams = {
  module: string,
  name: string,
  description: string,
  sub_module_type: 0 | 1,
  status: 0 | 1,
  parent: string,
  sub_module_question: any[]
}
const FETCH_MODULE_AVAILABLE_LIST = 'FETCH_MODULE_AVAILABLE_LIST';
const CREATE_MODULE = 'CREATE_MODULE';
const UPDATE_MODULE = 'UPDATE_MODULE';
const FETCH_MODULE_DETAIL = 'FETCH_MODULE_DETAIL';
const FETCH_SUBMODULE_TREE = 'FETCH_SUBMODULE_TREE';
const FETCH_SUBMODULE_V2 = 'FETCH_SUBMODULE_V2';

const CREATE_SUBMODULE = 'CREATE_SUBMODULE';
const DELETE_SUBMODULE = 'DELETE_SUBMODULE';
const FETCH_SUB_MODULE_DETAIL = 'FETCH_SUB_MODULE_DETAIL';
const FETCH_EDX_QUESTION_BY_MODULE = 'FETCH_EDX_QUESTION_BY_MODULE';
const UPDATE_SUBMODULE = 'UPDATE_SUBMODULE';
const DELETE_SUBMODULE_QUESTION = 'DELETE_SUBMODULE_QUESTION';
const FETCH_EDX_LIST_COURSE = 'FETCH_EDX_LIST_COURSE'
const SYNC_EDX_COURSE = 'SYNC_EDX_COURSE';
const SYNC_EDX_COURSE_DIRECT = 'SYNC_EDX_COURSE_DIRECT';
const CLONE_MODULE = 'CLONE_MODULE';
const FETCH_ACTIVE_SUBMODULE_CLASS_PRACTICE = 'FETCH_ACTIVE_SUBMODULE_CLASS_PRACTICE';
const CREATE_ACTIVE_SUBMODULE_CLASS_PRACTICE = 'CREATE_ACTIVE_SUBMODULE_CLASS_PRACTICE';

const CREATE_ACTIVE_SUBMODULE_CLASS_PRACTICE_V2 = 'CREATE_ACTIVE_SUBMODULE_CLASS_PRACTICE_V2';
const CREATE_ACTIVE_SUBMODULE_CLASS_EXAM = 'CREATE_ACTIVE_SUBMODULE_CLASS_EXAM';
const CREATE_EXAM_EXTEND = 'CREATE_EXAM_EXTEND';
const ADD_GRADE_MODULE = "ADD_GRADE_MODULE";
const DELETE_MODULE = 'DELETE_MODULE';

export type CreateExamExtendPayload = {
  class_id: number | string;
  submodule: number;
  time_active: string;
  time_end: string;
  student_ids: number[];
  extends_exams: number;
  module_id: string | null;
  type?: number;
};

export type CreateActiveSubmoduleClassExamPayload = {
  class_id: number | string;
  sub_module_id: number;
  module_id: string | null;
  time_active_days: string; // ISO
  time_end_days: string;     // ISO
  max_exam: number;
  time_value: number;
  exam_pass_score: number;
  type?: number;
};

export const fetchModuleAvailableList = createAction(FETCH_MODULE_AVAILABLE_LIST);

export const createModule = createAction(CREATE_MODULE, (data: createModuleData) => ({
  payload: {
    data
  }
}))

export const cloneModuleFromEdxCourse = createAction(CLONE_MODULE, (data: cloneModuleData) => ({
  payload: {
    data
  }
}))

export const updateModule = createAction(UPDATE_MODULE, (moduleId: string, data: createModuleData) => ({
  payload: {
    moduleId,
    data
  }
}))

export const fetchModuleDetail = createAction(FETCH_MODULE_DETAIL, (id: string) => ({
  payload: { id }
}))

export const fetchSubModuleTree = createAction(FETCH_SUBMODULE_TREE, (moduleId: string, practice_type: string, tree_type: string) => ({
  payload: { moduleId, practice_type, tree_type }
}))
export const fetchSubModuleV2 = createAction(FETCH_SUBMODULE_V2, (moduleId: string, class_id: string, practice_type?: string, active_class_submodules?: boolean, type?: number) => ({
  payload: { moduleId, class_id, practice_type, active_class_submodules, type }
}))

export const createSubModule = createAction(CREATE_SUBMODULE, (data: createSubModuleParams) => ({
  payload: {
    data: {
      module: data.module,
      name: data.name,
      description: data.description,
      sub_module_type: data.sub_module_type,
      status: data.status,
      parent: data.parent,
      sub_module_question: data.sub_module_question
    }
  }
}))

export const deleteSubModule = createAction(DELETE_SUBMODULE, ({ subModuleId, moduleId }: { subModuleId: string, moduleId: string }) => ({
  payload: {
    subModuleId, moduleId
  }
}))

export const fetchSubModuleDetail = createAction(FETCH_SUB_MODULE_DETAIL, (subModuleId: string) => ({
  payload: {
    subModuleId
  }
}))

export const fetchEdxQuestionByModule = createAction(FETCH_EDX_QUESTION_BY_MODULE, (blockId: string) => ({
  payload: {
    blockId
  }
}))

export const updateSubModule = createAction(UPDATE_SUBMODULE, ({ subModuleId, moduleId, data }: { subModuleId: string, moduleId: string, data: any }) => ({
  payload: { subModuleId, moduleId, data }
}))

export const deleteSubModlueQuestion = createAction(DELETE_SUBMODULE_QUESTION, ({ questionId, moduleId }: { questionId: string, moduleId: string }) => ({
  payload: {
    questionId, moduleId
  }
}))

export const fetchEdxListCourse = createAction(FETCH_EDX_LIST_COURSE);

export const syncEdxCourse = createAction(SYNC_EDX_COURSE, (id: string) => ({
  payload: { id }
}))

export const syncEdxCourseDirect = createAction(SYNC_EDX_COURSE_DIRECT, (courseId: string) => ({
  payload: { courseId }
}))

export const fetchActiveSubModuleClassPractice = createAction(FETCH_ACTIVE_SUBMODULE_CLASS_PRACTICE, ({ class_ids, module }: { class_ids: string[], module: string }) => ({
  payload: { class_ids, module }
}))

export const createActiveSubModuleClassPractice = createAction(CREATE_ACTIVE_SUBMODULE_CLASS_PRACTICE, (sub_module_id: string, class_id: string, submodule_name: string, module_id: string) => ({
  payload: { sub_module_id, class_id, submodule_name, module_id }
}))
export const createActiveSubModuleClassPracticeV2 = createAction(CREATE_ACTIVE_SUBMODULE_CLASS_PRACTICE_V2, (sub_module_ids: number[], class_id: string, module_id: string, type?: number) => ({
  payload: { sub_module_ids, class_id, module_id, type }
}))
export const createActiveSubmoduleClassExam = createAction(CREATE_ACTIVE_SUBMODULE_CLASS_EXAM, (payload: CreateActiveSubmoduleClassExamPayload) => ({
  payload
}))
export const createExamExtend = createAction(CREATE_EXAM_EXTEND, (payload: CreateExamExtendPayload) => ({
  payload
}))
export const addGradeModule = createAction(ADD_GRADE_MODULE, (moduleIds: string[], gradeId: string[]) => ({
  payload: {
    moduleIds,
    gradeId
  }
}));

export type DeleteModulePayload = {
  id: string;
};

export const deleteModule = createAction<DeleteModulePayload>(DELETE_MODULE);
